const EuroFlag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor' {...props}>
    <g clipPath='url(#clip0_1061_64441)'>
      <path
        d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
        fill='#0052B4'
      />
      <path
        d='M8.00051 3.13037L8.25954 3.92753H9.09766L8.41957 4.42018L8.6786 5.21734L8.00051 4.72465L7.32238 5.21734L7.58141 4.42018L6.90332 3.92753H7.74148L8.00051 3.13037Z'
        fill='#FFDA44'
      />
      <path
        d='M4.55682 4.55685L5.3037 4.93735L5.89635 4.34473L5.7652 5.17254L6.51204 5.55307L5.6842 5.6842L5.55307 6.51207L5.17254 5.76523L4.34473 5.89638L4.93738 5.30373L4.55682 4.55685Z'
        fill='#FFDA44'
      />
      <path
        d='M3.13086 8.00002L3.92802 7.74099V6.90283L4.42064 7.58096L5.21783 7.32193L4.72511 8.00002L5.21783 8.67811L4.42064 8.41911L3.92802 9.09721V8.25905L3.13086 8.00002Z'
        fill='#FFDA44'
      />
      <path
        d='M4.55682 11.4435L4.93735 10.6966L4.34473 10.1039L5.17257 10.2351L5.55304 9.48828L5.6842 10.3161L6.51201 10.4473L5.76526 10.8278L5.89635 11.6556L5.3037 11.0629L4.55682 11.4435Z'
        fill='#FFDA44'
      />
      <path
        d='M8.00051 12.8696L7.74145 12.0725H6.90332L7.58145 11.5798L7.32238 10.7827L8.00051 11.2753L8.6786 10.7827L8.41957 11.5798L9.09766 12.0725H8.25951L8.00051 12.8696Z'
        fill='#FFDA44'
      />
      <path
        d='M11.4434 11.4435L10.6966 11.063L10.1039 11.6556L10.2351 10.8278L9.48828 10.4473L10.3161 10.3161L10.4472 9.48828L10.8277 10.2351L11.6555 10.1039L11.0629 10.6967L11.4434 11.4435Z'
        fill='#FFDA44'
      />
      <path
        d='M12.8701 8.00002L12.073 8.25905V9.09721L11.5803 8.41908L10.7832 8.67811L11.2759 8.00002L10.7832 7.32193L11.5803 7.58096L12.073 6.90283V7.74102L12.8701 8.00002Z'
        fill='#FFDA44'
      />
      <path
        d='M11.4434 4.55682L11.0629 5.3037L11.6556 5.89635L10.8277 5.76516L10.4472 6.51201L10.3161 5.68416L9.48828 5.55301L10.2351 5.17251L10.1039 4.34473L10.6966 4.93735L11.4434 4.55682Z'
        fill='#FFDA44'
      />
    </g>
    <defs>
      <clipPath id='clip0_1061_64441'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default EuroFlag;
